"use client";

import { IconChevronLeft, IconClear } from "@/components";
import { useRouter } from "next/navigation";

interface MobileNavHeaderProps {
    onBack?: () => void;
    onClose?: () => void;
    title?: string;
}

const MobileNavHeader: React.FC<MobileNavHeaderProps> = ({
    onBack,
    onClose,
    title
}) => {
    const router = useRouter();

    const handleBack = () => {
        if (onBack) {
            onBack();
        } else {
            router.back();
        }
    };

    const handleClose = () => {
        if (onClose) {
            onClose();
        } else {
            router.push("/");
        }
    };

    return (
        <div className="fixed top-0 left-0 right-0 z-[80] bg-white lg:relative lg:z-auto md:hidden">
            <div className="flex items-center justify-between px-4 py-6">
                <button onClick={handleBack} className="text-2xl font-light">
                    <IconChevronLeft width={12} height={20} />
                </button>
                <button onClick={handleClose} className="text-xl font-light">
                    <IconClear width={15} height={15} />
                </button>
            </div>
            {title && (
                <div className="w-full">
                    <h1
                        className="wishlist-header-mobile inline-block"
                        style={{
                            marginLeft: '16px',
                            marginBottom: '12px',
                            borderBottom: '2px solid var(--color-black, #1C1C1C)',
                            paddingBottom: '12px'
                        }}
                    >
                        {title}
                    </h1>
                </div>
            )}
        </div>
    );
};

export default MobileNavHeader; 